import { AcquisitionExplorerIcon } from '@hcs/design-system';
import { AppConfig, AppSlugs } from '@hcs/types';

import AcquisitionExplorerProductImage from '../../assets/product-images/aexp_simplified.jpg';

export const APP_CONFIG_AEXP: AppConfig = {
  name: 'Acquisition Explorer',
  applicationKey: 'aexp',
  type: 'product',
  appSlugForEngagement: AppSlugs.AcquisitionExplorer,
  rootPath: `/aexp`,
  Icon: AcquisitionExplorerIcon,
  descriptionLong: [
    'Research rental investments faster,',
    'evaluate smarter, and purchase confidently.',
  ],
  descriptionShort:
    'Create buyboxes to identify target properties across any market of your choice.',
  marketingUrl: 'https://www.housecanary.com/products/acquisition-explorer/',
  marketingImage: AcquisitionExplorerProductImage,
};

export const VIEW_PATHS_AEXP = {
  BUY_BOXES: 'buy-boxes',
  MAP: 'map',
  ACTIVITY: 'activity',
  ACTIVITY_MONITOR: 'activity_monitor',
  ACTIVITY_PROPERTY_SEARCH: 'activity_property_search',
  OFFER: 'offer',
} as const;
